import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import { CORP_SEND_FILE_URL } from 'src/views/Pages/Onboarding/flowConfig'
import utils from '../../../../../components/Organisms/Form/utils'
import globalConsts from '../../globalConsts'

import Label from 'src/components/Atoms/Label/Label'
import InputFilesGroup from 'src/views/Forms/Components/InputFilesGroup/InputFilesGroup'
import Font from 'src/components/Core/Typography/Font/Font'
import { ExternalLink } from 'src/components/Core/Styles/Link'

export const tradersExperienceTemplate = <ExternalLink href='https://www.sucdenfinancial.com/media/330bpdzf/sfl-traders-individual-experience-form.pdf' />

const LabelEntityNameLei = (
  <Font
    key='entityNameLEI'
    gridArea='entityNameLEI'
    ellipsis={false}
  >
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.ExperienceForm.visualOnly.entityNameLEI'} />
  </Font>
)

const LabelInputFiles = (
  <Label
    key='labelInputFIlesSection'
    label={
      <Trans i18nKey={'onboarding.forms.CorporateAccount.ExperienceForm.visualOnly.labelInputFilesSection'}
        components={{ tradersExperienceTemplate }}
      />
    }
  />
)

const LabelHaveEvidenceInputFiles = (
  <Label
    key='labelInputFIlesSection'
    label={
      <Trans i18nKey={'onboarding.forms.CorporateAccount.ExperienceForm.visualOnly.haveEvidenceLabelInput'}
      />
    }
  />
)

// @ts-ignore:next-line
const pleaseConfirm = (
  <Font key='pleaseConfirm' ellipsis={false} margin='16px 0 8px 0'>
    <Trans i18nKey={'onboarding.forms.CorporateAccount.ExperienceForm.visualOnly.pleaseConfirm'} />
  </Font>
)

const config = () => {

  return utils.injectTranslation({
    id: 'ExperienceForm',
    path: 'onboarding.forms.CorporateAccount.ExperienceForm.inputs',
    keysToRemove: ['visual', 'documentID'],
    content: [
      {
        componentType: 'grid',
        props: {
          marginBottom: '16px'
        },
        content: [
          {
            componentType: 'radioButton',
            props: {
              name: 'eTradersExperience',
              id: 'companyTreasury',
              value: 'companyTreasury',
              //@ts-ignore 
              label: <Trans i18nKey={'onboarding.forms.CorporateAccount.ExperienceForm.radioOptions.companyTreasury'} />,
              display: 'inline',
              minWidth: '24px',
              marginWrapper: '24px 0 0 0'
            },
          },
        ]
      },
      {
        componentType: 'grid',
        props: {
          padding: '0 0 0 4%',
          boxSizing: 'border-box'
        },
        path: 'onboarding.forms.CorporateAccount.ExperienceForm.inputs',
        content: [
          {
            componentType: 'dropdown',
            transformType: 'indexToValue',
            props: {
              name: 'noOfQualifiedProfessionals',
              minHeight: '0',
              fixWidth: true,
              dontClearValue: true,
              noReset: true
            },
            secondaryName: 'companyTreasuryHowMany'
          },
          {
            componentType: 'grid',
            content: [
              {
                componentType: 'grid',
                props: {
                  padding: '0 0 0 4%',
                  boxSizing: 'border-box'
                },
                content: [
                  {
                    visualComponent: LabelInputFiles,
                    visualName: 'companyTreasuryLabelInputFiles',
                  },
                  {
                    props: {
                      name: globalConsts.INPUT_FILES_CORPORATE_EXPERIENCE_TRADEREXPERIENCEFORMS,
                      required: true,
                    },
                    custom: props => InputFilesGroup({
                      margin: '0 0 24px 0',
                      inputMargin: '0 0 8px 0',
                      inputLabel: t('onboarding.forms.CorporateAccount.ExperienceForm.visualOnly.inputFileLabel', { inputType: 'Trader Experience Form' }),
                      buttonLabel: t('onboarding.forms.CorporateAccount.ExperienceForm.button.addInputFileRow', { inputType: 'Add trader experience form' }),
                      fetchOptions: {
                        requestConfig: {
                          url: CORP_SEND_FILE_URL
                        }
                      },
                      step: '10',
                      name: globalConsts.INPUT_FILES_CORPORATE_EXPERIENCE_TRADEREXPERIENCEFORMS,
                      itemKey: 'companyTreasuryInputFilesComponent',
                      dynamicNumberOfFiles: true,
                      removeAddButton: true,
                      removeRemoveButton: true,
                      ...props
                    }),
                    visualName: 'companyTreasuryInputFilesComponent',
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        componentType: 'grid',
        props: {
          marginBottom: '16px'
        },
        content: [
          {
            componentType: 'radioButton',
            props: {
              name: 'eTradersExperience',
              id: 'companyCommittee',
              value: 'companyCommittee',
              label: <Trans i18nKey={'onboarding.forms.CorporateAccount.ExperienceForm.radioOptions.companyCommittee'} />,
              display: 'inline',
              minWidth: '24px',
            },
          },
        ]
      },
      {
        componentType: 'grid',
        props: {
          padding: '0 0 0 4%',
          boxSizing: 'border-box'
        },
        path: 'onboarding.forms.CorporateAccount.ExperienceForm.inputs',
        content: [
          {
            componentType: 'dropdown',
            transformType: 'indexToValue',
            props: {
              name: 'noOfQualifiedProfessionals',
              minHeight: '0',
              fixWidth: true,
              dontClearValue: true,
              noReset: true
            },
            secondaryName: 'companyCommitteeHowMany'
          },
          {
            componentType: 'grid',
            content: [
              {
                componentType: 'grid',
                props: {
                  padding: '0 0 0 4%',
                  boxSizing: 'border-box'
                },
                content: [
                  {
                    visualComponent: LabelInputFiles,
                    visualName: 'companyCommitteeLabelInputFiles'
                  },
                  {
                    props: {
                      name: globalConsts.INPUT_FILES_CORPORATE_EXPERIENCE_TRADEREXPERIENCEFORMS,
                      required: true,
                    },
                    custom: props => InputFilesGroup({
                      margin: '0 0 24px 0',
                      inputMargin: '0 0 8px 0',
                      inputLabel: t('onboarding.forms.CorporateAccount.ExperienceForm.visualOnly.inputFileLabel', { inputType: 'Trader Experience Form' }),
                      buttonLabel: t('onboarding.forms.CorporateAccount.ExperienceForm.button.addInputFileRow', { inputType: 'Add trader experience form' }),
                      fetchOptions: {
                        requestConfig: {
                          url: CORP_SEND_FILE_URL
                        }
                      },
                      step: '10',
                      name: globalConsts.INPUT_FILES_CORPORATE_EXPERIENCE_TRADEREXPERIENCEFORMS,
                      itemKey: 'companyCommitteeInputFilesComponent',
                      dynamicNumberOfFiles: true,
                      removeAddButton: true,
                      removeRemoveButton: true,
                      ...props
                    }),
                    visualName: 'companyCommitteeInputFilesComponent',
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        componentType: 'grid',
        props: {
          marginBottom: '16px'
        },
        content: [
          {
            componentType: 'radioButton',
            props: {
              name: 'eTradersExperience',
              id: 'companyAlgorithms',
              value: 'companyAlgorithms',
              label: t('onboarding.forms.CorporateAccount.ExperienceForm.radioOptions.companyAlgorithms'),
              display: 'inline',
              minWidth: '24px',

            },
          },
        ]
      },
      {
        componentType: 'grid',
        props: {
          padding: '0 0 0 4%',
          boxSizing: 'border-box'
        },
        path: 'onboarding.forms.CorporateAccount.ExperienceForm.inputs',
        content: [
          {
            componentType: 'dropdown',
            transformType: 'indexToValue',
            props: {
              name: 'noOfQualifiedProfessionals',
              minHeight: '0',
              fixWidth: true,
              dontClearValue: true,
              noReset: true
            },
            secondaryName: 'companyAlgorithmsHowMany'
          },
          {
            componentType: 'grid',
            content: [
              {
                componentType: 'grid',
                props: {
                  padding: '0 0 0 4%',
                  boxSizing: 'border-box'
                },
                content: [
                  {
                    visualComponent: LabelInputFiles,
                    visualName: 'companyAlgorithmsLabelInputFiles'
                  },
                  {
                    props: {
                      name: globalConsts.INPUT_FILES_CORPORATE_EXPERIENCE_TRADEREXPERIENCEFORMS,
                      required: true,
                    },
                    custom: props => InputFilesGroup({
                      margin: '0 0 24px 0',
                      inputMargin: '0 0 8px 0',
                      inputLabel: t('onboarding.forms.CorporateAccount.ExperienceForm.visualOnly.inputFileLabel', { inputType: 'Trader Experience Form' }),
                      buttonLabel: t('onboarding.forms.CorporateAccount.ExperienceForm.button.addInputFileRow', { inputType: 'Add trader experience form' }),
                      fetchOptions: {
                        requestConfig: {
                          url: CORP_SEND_FILE_URL
                        }
                      },
                      step: '10',
                      name: globalConsts.INPUT_FILES_CORPORATE_EXPERIENCE_TRADEREXPERIENCEFORMS,
                      itemKey: 'companyAlgorithmsInputFilesComponent',
                      dynamicNumberOfFiles: true,
                      removeAddButton: true,
                      removeRemoveButton: true,
                      ...props
                    }),
                    visualName: 'companyAlgorithmsInputFilesComponent',
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        componentType: 'grid',
        props: {
          marginBottom: '16px'
        },
        content: [
          {
            componentType: 'radioButton',
            props: {
              name: 'eTradersExperience',
              id: 'companyExternal',
              value: 'companyExternal',
              label: t('onboarding.forms.CorporateAccount.ExperienceForm.radioOptions.companyExternal'),
              display: 'inline',
              minWidth: '24px',
            },
          },
        ]
      },
      {
        componentType: 'grid',
        content: [
          {
            componentType: 'grid',
            path: 'onboarding.forms.CorporateAccount.ExperienceForm.inputs',
            content: [
              {
                componentType: 'grid',
                props: {
                  gridTemplateColumns: '1fr 1fr',
                  gridTemplateAreas:
                      '\'entityNameLEI entityNameLEI\' \'entityName lei\'',
                  marginBottom: 'auto',
                  rowGap: '16px',
                  marginLeft: '8%',
                },
                content: [
                  {
                    visualComponent: LabelEntityNameLei,
                    visualName: 'companyExternalLabelEntityNameLei',
                  },
                  {
                    componentType: 'input',
                    props: {
                      name: 'entityName',
                      gridArea: 'entityName',
                      label: t('onboarding.forms.CorporateAccount.ExperienceForm.inputs.entityName.label'),
                      placeholder: t('onboarding.forms.CorporateAccount.ExperienceForm.inputs.entityName.placeholder'),
                      required: true,
                      maxlength: 100,
                    },
                    secondaryName: 'companyExternalEntityName'
                  },
                  {
                    componentType: 'input',
                    props: {
                      name: 'lei',
                      gridArea: 'lei',
                      label: t('onboarding.forms.CorporateAccount.ExperienceForm.inputs.lei.label'),
                      placeholder: t('onboarding.forms.CorporateAccount.ExperienceForm.inputs.lei.placeholder'),
                      required: true,
                      maxlength: 100,
                    },
                    secondaryName: 'companyExternalLei'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        componentType: 'grid',
        props: {
          marginBottom: '16px'
        },
        content: [
          {
            componentType: 'radioButton',
            props: {
              name: 'eTradersExperience',
              id: 'companyRelatedEntity',
              value: 'companyRelatedEntity',
              label: t('onboarding.forms.CorporateAccount.ExperienceForm.radioOptions.companyRelatedEntity'),
              display: 'inline',
              minWidth: '24px',
            },
          },
        ]
      },
      {
        componentType: 'grid',
        content: [
          {
            componentType: 'grid',
            path: 'onboarding.forms.CorporateAccount.ExperienceForm.inputs',
            content: [
              {
                componentType: 'grid',
                props: {
                  gridTemplateColumns: '1fr 1fr',
                  gridTemplateAreas:
                      '\'entityNameLEI entityNameLEI\' \'entityName lei\'',
                  marginBottom: 'auto',
                  rowGap: '16px',
                  marginLeft: '8%',
                },
                content: [
                  {
                    visualComponent: LabelEntityNameLei,
                    visualName: 'companyRelatedEntityLabelEntityNameLei'
                  },
                  {
                    componentType: 'input',
                    props: {
                      name: 'entityName',
                      gridArea: 'entityName',
                      label: t('onboarding.forms.CorporateAccount.ExperienceForm.inputs.entityName.label'),
                      placeholder: t('onboarding.forms.CorporateAccount.ExperienceForm.inputs.entityName.placeholder'),
                      required: true,
                      maxlength: 100,
                    },
                    secondaryName: 'companyRelatedEntityEntityName'
                  },
                  {
                    componentType: 'input',
                    props: {
                      name: 'lei',
                      gridArea: 'lei',
                      label: t('onboarding.forms.CorporateAccount.ExperienceForm.inputs.lei.label'),
                      placeholder: t('onboarding.forms.CorporateAccount.ExperienceForm.inputs.lei.placeholder'),
                      required: true,
                      maxlength: 100,
                    },
                    secondaryName: 'companyRelatedEntityLei'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        componentType: 'grid',
        props: {
          marginBottom: '16px',
          padding: '16px 0 0 0'
        },
        content: [
          {
            componentType: 'radioButton',
            props: {
              name: 'eTradersExperience',
              id: 'companyRegulated',
              value: 'companyRegulated',
              label: t('onboarding.forms.CorporateAccount.ExperienceForm.radioOptions.companyRegulated'),
              display: 'inline',
              minWidth: '24px'
            },
          },
        ]
      },
      {
        componentType: 'grid',
        content: [
          {
            componentType: 'radioGroup',
            props: {
              name: 'isEvidencesDocumentationProvided',
              minHeight: '0',
              label: <Trans i18nKey={'onboarding.forms.CorporateAccount.ExperienceForm.inputs.isEvidencesDocumentationProvided.label'}/>,
              removeLabelEllipsis: true,
              dataList: [
                {
                  id: 'isEvidencesDocumentationProvided1',
                  label: t('components.forms.labels.yes'),
                  value: 'true',
                },
                {
                  id: 'isEvidencesDocumentationProvided2',
                  label: t('components.forms.labels.no'),
                  value: 'false',
                },
              ],
              required: true,
            },
          }
        ]
      },
      {
        needTranslationInjection: false,
        componentType: 'grid',
        props: {
          padding: '0 0 0 4%',
          boxSizing: 'border-box'
        },
        content: [
          {
            componentType: '',
            visualComponent: LabelHaveEvidenceInputFiles,
            visualName: 'haveEvidenceLabelInputFiles'
          },
          {
            componentType: '',
            props: {
              name: globalConsts.INPUT_FILES_CORPORATE_EXPERIENCE_EVIDENCES,
              required: true,
            },
            custom: props => InputFilesGroup({
              inputMargin: '0 0 8px 0',
              inputLabel: t('onboarding.forms.CorporateAccount.ExperienceForm.visualOnly.inputFileLabel', { inputType: 'Evidence' }),
              buttonLabel: t('onboarding.forms.CorporateAccount.ExperienceForm.button.addInputFileRow', { inputType: 'Evidence' }),
              fetchOptions: {
                requestConfig: {
                  url: CORP_SEND_FILE_URL
                }
              },
              step: '10',
              name: globalConsts.INPUT_FILES_CORPORATE_EXPERIENCE_EVIDENCES,
              ...props
            }),
            visualName: 'haveEvidenceInputFilesComponent'
          }
        ]
      },
      {
        componentType: 'grid',
        props: {
          padding: '24px 0 0 0'
        },
        content: [
          {
            componentType: 'radioGroup',
            props: {
              name: 'isFund',
              minHeight: '0',
              label: <Trans i18nKey={'onboarding.forms.CorporateAccount.ExperienceForm.inputs.isFund.label'}/>,
              removeLabelEllipsis: true,
              dataList: [
                {
                  id: 'isFund1',
                  label: t('components.forms.labels.yes'),
                  value: 'true',
                },
                {
                  id: 'isFund2',
                  label: t('components.forms.labels.no'),
                  value: 'false',
                },
              ],
              required: true,
            },
          },
          {
            componentType: '',
            visualComponent: pleaseConfirm,
            visualName: 'pleaseConfirm',
          },
          {
            componentType: 'input',
            props: {
              name: 'isFundEntity',
              removeLabelEllipsis: true,
              required: true,
            },
          },
          {
            componentType: 'input',
            submitValidation: 'lei',
            props: {
              name: 'isFundLei',
              removeLabelEllipsis: true,
              required: true,
            },
          },
        ]
      },
    ],
  })}

export default config
